"use client";

import { Container } from "react-bootstrap";
// import { Link } from "react-router-dom";

const HeroBanner = () => {
  return (
    <>
      <div className="banner-area bg-img pb-0" id="home">
        <Container className="position-relative z-1">
          <div className="banner-img-wrap text-center">
            <img
              src="/images/tuviendenthanh/logo.jpg"
              alt="banner-img"
              width={848}
              height={585}
            />
          </div>

          
        </Container>
      </div>
    </>
  );
};

export default HeroBanner;
